// extracted by mini-css-extract-plugin
export var bodySections = "_9l-8";
export var gray = "_9l-7";
export var green = "_9l-4";
export var iconContainer = "_9l-9";
export var iconWidgetContainer = "_9l-1";
export var phoneIcon = "_9l-2";
export var red = "_9l-5";
export var statusDot = "_9l-3";
export var widgetContainer = "_9l-0";
export var yellow = "_9l-6";